/**
 * /library/wiki/$articleId/edit — redirect to the inline editor.
 *
 * #223 — the documented IA uses `/library/wiki/$id/edit`, but
 * editing happens inside `/library/documents` driven by the
 * `?edit=<articleId>` query param (LIB-03 behaviour shipped in
 * round 1). Deep links land users in the right editor state.
 *
 * #236 (round 6) — same component-Navigate timing bug as
 * `/library/wiki/new`: the destination component mounts and
 * reads `window.location.search` BEFORE TanStack syncs the
 * search param. Fix follows the same shape: `beforeLoad` +
 * `throw redirect()`.
 *
 * #1337 follow-up — use raw `href`, not `{ to, search }`, for the same
 * reason as `/library/wiki/new`: live ai1 showed the typed search-object
 * redirect can pass source tests but still drop the destination action.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/library/wiki/$articleId/edit')({
  beforeLoad: ({ params }) => {
    throw redirect({
      href: `/library/documents?edit=${encodeURIComponent(params.articleId)}`,
      replace: true,
    });
  },
});
